<!-- =========================================================================================
  File Name: ProjectView.vue
  Description: Project View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/project/pixinvent
========================================================================================== -->

<template>
  <div id="page-project-view">
    <vs-alert
      color="danger"
      title="Project Not Found"
      :active.sync="project_not_found"
    >
      <span
        >Project record with id: {{ $route.params.projectId }} not found.
      </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-project-list' }"
          class="text-inherit underline"
          >All Projects</router-link
        >
      </span>
    </vs-alert>
    <div id="project-data" v-if="project_data">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img :src="project_data.project_cover_img" alt="project-cover-img" class="responsive block">
        </div>
      </div>
      <vx-card title="Project Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="project_data.project_logo" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td>Project Name</td>
                <td class="font-semibold">{{ project_data.project_name }}</td>
              </tr>
              <tr></tr>
              <tr>
                <td>Address</td>
                <td class="font-semibold">{{ projectAddress }}</td>
              </tr>
              <tr>
                <td>Company</td>
                <td class="font-semibold">{{ project_data.company }}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <vs-chip
                    class="chip"
                    :color="chipColor(project_data.status)"
                  >
                    <span>{{ project_data.status }}</span>
                  </vs-chip>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td>Property type</td>
                <td class="font-semibold">{{ project_data.property_type }}</td>
              </tr>
              <tr>
                <td>Units qty</td>
                <td class="font-semibold">{{ project_data.units_qty }}</td>
              </tr>
              <tr>
                <td>Gross area</td>
                <td class="font-semibold">
                  {{ project_data.gross_area }} m<sup>2</sup>
                </td>
              </tr>
              <tr>
                <td>Sales price range</td>
                <td class="font-semibold">
                  {{ project_data.sales_price_range[0] }} - {{ project_data.sales_price_range[1] }} €/m<sup>2</sup>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex justify-end" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              type="border"
              color="danger"
              :to="{
                name: 'app-project-edit',
                params: { projectId: $route.params.projectId }
              }"
              >Edit</vs-button
            >
            <vs-button
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
              >Delete</vs-button
            >
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Contacts" class="mb-base">
            <table>
              <tr>
                <td>Mobile</td>
                <td class="font-semibold">{{ project_data.mobile }}</td>
              </tr>
              <tr>
                <td>Website</td>
                <td class="font-semibold">{{ project_data.website }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td class="font-semibold">{{ project_data.email }}</td>
              </tr>
              <tr>
                <td>Contact</td>
                <td class="font-semibold">
                  {{ project_data.contact_options.join(", ") }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Social Links" class="mb-base">
            <table>
              <tr v-if="project_data.social_links.twitter">
                <td>Twitter</td>
                <td class="font-semibold">
                  {{ project_data.social_links.twitter }}
                </td>
              </tr>
              <tr>
                <td>Facebook</td>
                <td class="font-semibold">
                  {{ project_data.social_links.facebook }}
                </td>
              </tr>
              <tr>
                <td>Instagram</td>
                <td class="font-semibold">
                  {{ project_data.social_links.instagram }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

      <!-- Design Packages -->
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Configuration Packages</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full wishlists-table">
            <tr>
              <!--
                You can also use `Object.keys(Object.values(data_local.wishlists)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               -->
              <th
                class="font-semibold text-base text-left px-3 py-2"
                v-for="heading in [
                  'Title',
                  'Category',
                  'Products qty',
                  'Attached'
                ]"
                :key="heading"
              >
                {{ heading }}
              </th>
            </tr>

            <tr v-for="(val, name) in project_data.wishlists" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td
                v-for="(wishlist, name) in val"
                class="px-3 py-2"
                :key="name + wishlist"
              >
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr>
          </table>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleProjectManagement from "@/store/project-management/moduleProjectManagement.js";

export default {
  data() {
    return {
      project_data: null,
      project_not_found: false
    };
  },
  computed: {
    projectAddress() {
      let str = "";
      for (const [key, value] of Object.entries(this.project_data.location)) {
        str += `${value} `;
      }
      return str;
    },
    chipColor() {
      return value => {
        if (value === "active") return "success";
        else if (value === "inactive") return "danger";
        else if (value === "archived") return "warning";
        else return "primary";
      };
    }
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.project_data.project_name}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.$router.push({ name: "app-project-list" });
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting project */
      this.$store
        .dispatch("projectManagement/removeRecord", this.project_data.id)
        .then(() => {
          this.$router.push({ name: "app-project-list" });
          this.showDeleteSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Project Deleted",
        text: "The selected project was successfully deleted"
      });
    }
  },
  created() {
    // Register Module ProjectManagement Module
    if (!moduleProjectManagement.isRegistered) {
      this.$store.registerModule("projectManagement", moduleProjectManagement);
      moduleProjectManagement.isRegistered = true;
    }

    const projectId = this.$route.params.projectId;
    this.$store
      .dispatch("projectManagement/fetchProject", projectId)
      .then(res => {
        this.project_data = res.data;
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.project_not_found = true;
          return;
        }
        console.error(err);
      });
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-project-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
